<template>
    <div class="borrow-success">
        <div class="success-msg">
            <template v-if="isBorrowSuccess === 1">
                <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="43" cy="43" r="43" fill="white"/>
                    <circle cx="43" cy="43" r="43" fill="#58B469"/>
                    <path d="M22.4258 46.5774L37.2496 61.4013C37.6401 61.7918 38.2733 61.7918 38.6638 61.4013L67.2362 32.8289" stroke="#FEFEFE" stroke-width="6" stroke-linecap="round"/>
                </svg>
                <h1>{{ $t('m.rentalSuccessTitle') }}</h1>
                <h2 v-html="replaceTranslateContent($t('m.rentalSuccessSubtitle'))"/>
            </template>
            <template v-if="isBorrowSuccess === -1">
                <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="43" cy="43" r="43" fill="white"/>
                    <circle cx="43" cy="43" r="43" fill="#C9212E"/>
                    <path d="M58.5547 27.4437L27.442 58.5564" stroke="white" stroke-width="6" stroke-linecap="round"/>
                    <path d="M27.4414 27.4437L58.5541 58.5564" stroke="white" stroke-width="6" stroke-linecap="round"/>
                </svg>
                <h1>{{ $t('m.rentalFailTitle') }}</h1>
                <h2>{{ errorMsg }}</h2>
            </template>
        </div>
        <!-- 全屏加载组件 -->
        <PreparingCharger v-if="isShowPreparing"></PreparingCharger>
    </div>
</template>

<script>
import {releasePowerBank} from "../../api/notLogin";
import PreparingCharger from "../../components/loading/PreparingCharger.vue";

export default {
    name: "PopUpDirectly",
    components: {PreparingCharger},
    data() {
        return {
            brandName: this.$store.getters['appConfig/brand_name'],
            isShowPreparing: true,
            isBorrowSuccess: 0,
            errorMsg: ''
        }
    },
    created() {
        this.releasePowerBank()
    },
    methods: {
        releasePowerBank() {
            releasePowerBank({code: this.$store.getters['appConfig/device_code']})
            .then(() => {
                this.isBorrowSuccess = 1
            })
            .catch((err) => {
                this.errorMsg = err.message
                this.isBorrowSuccess = -1
            })
            .finally(() => {
                this.isShowPreparing = false
            })
        }
    }
};
</script>

<style lang="scss">
    .success-msg {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        svg {
            width: 86px;
        }
        h1 {
            margin: 0;
            font-family: Sarala;
            font-size: 26px;
            font-weight: 700;
            line-height: 31.2px;
            margin-top: 20px;
            margin-bottom: 15px;
        }
        h2 {
            margin: 0;
            width: 283px;
            font-size: 14px;
            font-weight: 400;
            line-height: 20.16px;
            color: #333333;
            text-align: center;
        }
    }
</style>
